var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnPlashkaWriteme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 533.3 93.7",
    style: {
      enableBackground: "new 0 0 533.3 93.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.2,4.5L79.1,93.7l-34-54.5l-34,54.5L0,4.5h9.1l7.9,63l28.2-45.1l28.2,45.1l7.9-63H90.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.8,4.5c12.2,0,22,9.8,22,22c0,11.1-7.7,19.6-18.5,21.7l21.2,41h-10.3l-20.6-39.6L112,53.1v36.1h-9.1V4.5H141.8z  M141.8,13.3H112v30.9l30.1-4.5c7.1-1.1,12.3-5.7,12.3-13.2C154.5,19.5,148.9,13.3,141.8,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.8,4.5h9.1v84.7h-9.1V4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.1,4.5v8.8h-30.3v75.9h-9V13.3h-30.3V4.5H268.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.8,13.3h-50V41h35.5v8.8h-35.5v30.5h50v8.8h-59V4.4h59V13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.6,89.2h-9.1L383.6,0l34,54.5l34-54.5l11.1,89.2h-9.1l-7.9-63l-28.2,45.1l-28.2-45.1L381.6,89.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.3,13.3h-50V41h35.5v8.8h-35.5v30.5h50v8.8h-59V4.4h59V13.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnPlashkaWriteme);
export default __webpack_public_path__ + "static/media/EN_PLASHKA_write me.5520a463c402676efb38ad65b1790086.svg";
export { ForwardRef as ReactComponent };